// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchProduct_searchContainer__J5il1","searchBox":"SearchProduct_searchBox__i43SB"};